export const useCookieValue = <T>(
  key: string,
  defaultValue: T,
): T => {
  const cookies = document?.cookie ?? '';
  const parseCookies = cookies.split(';');
  const cookieValues = parseCookies.map((str) => str.split('='));

  for (const cookie of cookieValues) {
    if (cookie[0].replace(' ', '') === key) {
      return cookie[1] as unknown as T;
    }
  }

  return defaultValue;
};
